export function initSelect() {
  let ignoredIds = new Set();
  const selectedList = new Set();
  const updateListeners = [];
  const selectListeners = [];
  const unselectListeners = [];
  const unselectAllListeners = [];

  return {
    onUpdate: (fn) => {
      updateListeners.push(fn);
    },
    onSelect: (fn) => {
      selectListeners.push(fn);
    },
    onUnselect: (fn) => {
      unselectListeners.push(fn);
    },
    onUnselectAll: (fn) => {
      unselectAllListeners.push(fn);
    },
    toggle,
    contains,
    select,
    unselect,
    unselectAll,
    setIgnoreList,
    list: () => selectedList,
    array: () => Array.from(selectedList),
  };

  function emitOnUpdate() {
    updateListeners.forEach((fn) => fn(selectedList));
  }

  function emitOnSelect(id) {
    selectListeners.forEach((fn) => fn(id));
  }

  function emitOnUnselect(id) {
    unselectListeners.forEach((fn) => fn(id));
  }

  function emitOnUnselectAll() {
    unselectAllListeners.forEach((fn) => fn());
  }

  function toggle(id) {
    if (contains(id)) {
      unselect(id);
    } else {
      select(id);
    }
  }

  function unselect(id) {
    selectedList.delete(id);
    emitOnUnselect(id);
    emitOnUpdate();
  }

  function unselectAll() {
    selectedList.clear();
    emitOnUnselectAll();
    emitOnUpdate();
  }

  function select(id) {
    if (ignoredIds.has(id)) return;
    selectedList.add(id);
    emitOnSelect(id);
    emitOnUpdate();
  }

  function contains(id) {
    return selectedList.has(id);
  }

  function setIgnoreList(ignoreList = []) {
    ignoredIds = new Set(ignoreList);
  }
}
